import { Layout } from '@/components/generic';

import Content from './Content';
import Header from './Header';

export const VerificationIssues = () => {
  return (
    <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
      <Layout title='Verification Issues'>
        <div className='card px-12 py-22 max-lg:p-8 max-lg:px-6'>
          <div className='max-w-215 mx-auto'>
            <Header />
            <Content />
          </div>
        </div>
      </Layout>
    </div>
  );
};
